import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

export function MaintenancePage() {
  const navigate = useNavigate()

  const check = () => {
    void sessionApi.getMaintenanceStatus({}).then((res) => {
      const status = (res.data as { data?: { status?: boolean } })?.data?.status
      if (status) navigate('/maintenance', { replace: true })
      else if (status === false) navigate('/login', { replace: true })
      else navigate('/maintenance', { replace: true })
    })
  }

  useEffect(() => {
    check()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', textAlign: 'center', padding: 24 }}>
      <div>
        <h1>Sorry, we&apos;re down for maintenance.</h1>
        <p className="w7-dim">We&apos;ll be back shortly.</p>
        <Button variant="primary" onClick={check} style={{ marginTop: 24 }}>
          Back to Home
        </Button>
      </div>
    </div>
  )
}
